var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer color-link",on:{"click":function($event){return _vm.onClick()}}},[_vm._v(_vm._s(_vm.fullName))])
}
var staticRenderFns = []

export { render, staticRenderFns }